import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../../api/axios";
import { AuthContext } from "../../../Context/AuthContext";
import { jwtDecode } from "jwt-decode";
import Logo from "../../../assets/images/logo.png";
import HezeeLogo from "../../../assets/images/hezeelogo.png";
import Person from "../../../assets/images/Person.svg";
import Hotel from "../../../assets/images/Hotel.svg";
import Gym from "../../../assets/images/Gym.svg";
import Hospital from "../../../assets/images/Hospital.svg";
import PMS from "../../../assets/images/pms.svg";
import HRMS from "../../../assets/images/hrms.svg";
import LMS from "../../../assets/images/lms.svg";
import VMS from "../../../assets/images/vms.svg";
import PASS from "../../../assets/images/password-user.svg";
import "./Signin.css";

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [property_code, setPropertyCode] = useState("");
  const [loading, setLoading] = useState(false);
  const { login, allowedModules } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post("/login", {
        email,
        password,
        property_code,
      });
      const { token } = res.data.data;
      if (!token) {
        alert("Login failed — no token returned.");
        return;
      }

      // ✅ Decode token here
      const decoded = jwtDecode(token);
      const modules = decoded.modules || [];

      login(token);
      if (modules.includes("pms")) {
        navigate("/index", { replace: true });
      } else if (modules.includes("hrms"))
        navigate("/hrms-dashboard", { replace: true });
      else navigate("/signin", { replace: true });
    } catch (err) {
      alert("Login failed!");
    } finally {
      setLoading(false);
    }
  };

  const circleIcons = [
    { type: "text", label: "LMS" },
    { type: "text", label: "GYM" },
    { type: "img", src: Hotel },
    { type: "text", label: "VMS" },
    { type: "img", src: Person },
    { type: "text", label: "IMS" },
    { type: "img", src: Gym },
    { type: "text", label: "HRMS" },
    { type: "text", label: "CMS" },
    { type: "text", label: "PMS" },
    { type: "img", src: Hospital },
  ];

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12 col-sm-6 col-md-6 col-lg-7 col-xl-7 col-xxl-7 d-none d-sm-none d-md-block d-lg-block d-xl-block d-xxl-block">
          <div className="login-left">
            <div className="row">
              <div className="col-12">
                <div className="rotating-section">
                  <div className="center-logo">
                    <div className="logo-circle-1">
                      <div className="logo-circle">
                        <img src={Logo} alt="logo-img" />
                      </div>
                    </div>
                  </div>

                  <div className="orbit-container">
                    {circleIcons.map((icon, index) => (
                      <div
                        key={index}
                        className="orbit-circle position-absolute top-50 start-50"
                        style={{
                          transform: `rotate(${
                            index * (360 / circleIcons.length)
                          }deg) translate(150px) rotate(-${
                            index * (360 / circleIcons.length)
                          }deg)`,
                        }}
                      >
                        <div className="circle-icon d-flex flex-column align-items-center justify-content-center shadow **w-12 h-12**">
                          {icon.type === "img" ? (
                            <div className="circle-icon small">
                              <img
                                src={icon.src}
                                alt="icon"
                                className="img-fluid mb-1"
                              />
                            </div>
                          ) : (
                            <div className="circle-icon medium">
                              {icon.label}
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="col-12 sub-cards-main">
                <div className="system-cards">
                  <div className="sub-cards">
                    <h3 className="sub-cards-head">
                      <span className="sub-cards-icon">
                        <img src={PMS} />
                      </span>
                      PMS
                    </h3>
                    <p className="sub-cards-parah">Sign Up Your Account</p>
                  </div>
                  <div className="sub-cards">
                    <h3 className="sub-cards-head">
                      <span className="sub-cards-icon">
                        <img src={HRMS} />
                      </span>
                      HRMS
                    </h3>
                    <p className="sub-cards-parah">Sign Up Your Account</p>
                  </div>
                  <div className="sub-cards">
                    <h3 className="sub-cards-head">
                      <span className="sub-cards-icon">
                        <img src={LMS} />
                      </span>
                      LMS
                    </h3>
                    <p className="sub-cards-parah">Sign Up Your Account</p>
                  </div>
                  <div className="sub-cards">
                    <h3 className="sub-cards-head">
                      <span className="sub-cards-icon">
                        <img src={VMS} />
                      </span>
                      VMS
                    </h3>
                    <p className="sub-cards-parah">Sign Up Your Account</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-sm-6 col-md-5 col-lg-5 col-xl-5 col-xxl-5">
          <div className="login-right">
            <div className="login-form-container">
              <h1 className="form-title">et Started With US</h1>

              <div className="login-form">
                <div className="form-group">
                  <label htmlFor="email">Email*</label>
                  <div className="input-wrapper">
                    <input
                      type="email"
                      id="email"
                      placeholder="Enter your email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                    <span className="input-icon">✉︎</span>
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="password">Password*</label>
                  <div className="input-wrapper">
                    <input
                      type="password"
                      id="password"
                      placeholder="Enter password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <span className="input-icon">
                      <img src={PASS} />
                    </span>
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="propertyCode">Property Code*</label>
                  <div className="input-wrapper">
                    <input
                      type="text"
                      id="property_ode"
                      placeholder="Enter Property Code"
                      value={property_code}
                      onChange={(e) => setPropertyCode(e.target.value)}
                    />
                    <span className="input-icon">***</span>
                  </div>
                </div>

                <button
                  onClick={handleLogin}
                  className="login-button"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Logging in...
                    </>
                  ) : (
                    "Log In"
                  )}
                </button>
              </div>

              <div className="powered-by">
                <span>Powered by</span>
                <div className="hezee-logo">
                  <img src={HezeeLogo} alt="logo-image" />
                </div>
                <div className="website">www.hezee.co.in</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
